export default "__VITE_ASSET__kbp32$ru__"